<template>
  <div class="row">
    <div class="col-sm-12">
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="form-group col-sm-12 col-md-12 required">
            <label for="account_id">Account:</label>
            <Select2 name="account_id" v-model.number="account_id" :options="accountOptions"/>
          </div>
          <div class="form-group col-sm-12">
            <input class="btn btn-primary" required type="submit" value="Show" :disabled="this.onRequest">
          </div>
        </div>
      </form>
    </div>
    <div class="col-sm-12">
      <Datatable v-bind:entries="route_targets" :columns="columns" :title="'Routes Target'"/>
    </div>
    <div v-if="this.onRequest" class="modal-backdrop fade show" style="display:flex; align-items: center; justify-content: center;">
      <img :src="require('../assets/loading.gif')"/>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { getCapability } from '../_helpers'
  import Datatable from '../components/Datatable.vue'
  import Select2 from 'vue3-select2-component';
  export default {
    computed: {
      ...mapState('route_targets', ['route_targets', 'onRequest']),
      ...mapState('accounts', ['accounts']),
      ...mapState('users', ['user']),
      columns(){
        return [
          {name: 'account', text: 'Account',
            raw: {
              type: 'Sub',
              value: 'account_name'
            }
          },
          {name: 'route', text: 'Route',
            raw: {
              type: 'Sub',
              value: 'route_name'
            }
          },
          {name: 'year', text: 'Year', order: 'desc'},
          {name: 'month', text: 'Month',
            raw: {
              type: 'Text',
              fields: [
                {value: '1', text: 'January'},
                {value: '2', text: 'February'},
                {value: '3', text: 'March'},
                {value: '4', text: 'April'},
                {value: '5', text: 'May'},
                {value: '6', text: 'June'},
                {value: '7', text: 'July'},
                {value: '8', text: 'August'},
                {value: '9', text: 'September'},
                {value: '10', text: 'October'},
                {value: '11', text: 'November'},
                {value: '12', text: 'December'},
              ]
            }
          },
          {name: 'target', text: 'Target', raw: {type: 'format_number'}, class: 'text-right'},
          {name: 'action', text: 'Action',
            raw: {
              type: 'Action',
              fields: [
                getCapability('edit_route_target', this.user) ? {event: 'edit_route_target', text: 'Edit', method: 'get', class: 'btn btn-primary'} : {},
                getCapability('delete_route_target', this.user) ? {event: 'route_targets/destroy', text: 'Delete', method: 'post', class: 'btn btn-danger ml-1'} : {},
              ]
            }
          },
        ]
      }
    },
    data(){
      return {
        account_id: null,
        accountOptions: [],
      }
    },
    components:{
      Datatable,
      Select2,
    },
    methods: {
      ...mapActions('route_targets', {get_data: 'get_route_target_by_account'}),
      ...mapActions('accounts', ['get_all']),
      ...mapActions('alert', ['error', 'clear']),
      handleSubmit(){
        if(this.onRequest) return;
        this.clear()
        this.get_data({account_id: this.account_id})
      },
    },
    created() {
      this.$emit('onChildInit', 'Routes Target', getCapability('add_route_target', this.user) ? '/route_targets/add' : '')
      this.get_all()
    },
    watch: {
      accounts(nextState, prevState){
        if(nextState !== prevState){
          this.accountOptions = []
          if(nextState.length > 0){
            nextState.map(item => {
              this.accountOptions.push({id:item.id, text:item.account_name})
            })
            if(this.accountOptions.length > 0){
              this.account_id = this.accountOptions[0].id
              this.handleSubmit()
            }
          }
          return
        }
      },
    }
  }
</script>
